<template lang="pug">
div
    el-upload.upload_part_one(
        v-if="!value.reourceAddress" :show-file-list="false" name="Filedata" ref="upCmp"
        :accept="accept" :action="FILESERVICE" :data="upData" :auto-upload="false" :headers="upHeaders"
        :on-success="uploadSuccess" :on-error="onError" :before-upload="beforeUpload" :on-change="change"
    )
        .submit-btn(style="width: 200px;margin-top: 85px;")
            template(v-if="type == -1")
                span +上传
                span(style="color: #FDCB15;") {{orderData.contentTime}}s视频
                span 或
                span(style="color: #FDCB15;") 图片
            template(v-else)
                span +上传
                b(v-if="data.materialType == 1") {{orderData.contentTime}}秒
                | {{data.materialTypeName}}
        template(v-if="type != -1")
            p.color_999(v-if="data.materialType == 1" style="margin-top: 10px;font-size:12px;") 视频格式：mp4
            p.color_999(v-if="data.materialType == 2" style="margin-top: 10px;font-size:12px;") 图片格式png/jpg, 小于10M
        p.color_999(v-else style="margin-top: 10px;font-size:12px;") 格式mp4、jpg、png；最佳{{data.resolvingPower}}

    .video_main(v-if="value.reourceAddress")
        video.video_preview(v-if="type == 1 || type == -1" :src="value.reourceAddress" controls="controls" @click="playVideo" ref="resource")
        img(v-if="type == 2" :src="value.reourceAddress" @click="playVideo" ref="resource")
        i.icon-gouxuankuang-xuanzhongcopy.iconfont(@click="deleteCurrentVideo")

</template>

<script>
export default {
  name: "UploadVideo_v",
  props: {
    value: {
      type: Object,
      default() {
        return {};
      }
    },
    data: {
      type: Object,
      default() {
        return {};
      }
    },
    orderData: {
      type: Object,
      default() {
        return {};
      }
    },
    type: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      accept: "",
      upData: {},
      upHeaders: {
        token: localStorage.getItem('user_ticket') || undefined
      }
    };
  },
  created() {
    this.handleAccept();
  },
  methods: {
    handleAccept() {
      // 上传文件格式控制
      let tp = this.type - 0;
      if (tp === -1)
        this.accept = "video/mp4, image/png, image/jpg, image/jpeg";
      else if (tp === 1) this.accept = "video/mp4";
      else if (tp === 2) this.accept = "image/png, image/jpg, image/jpeg";
    },
    // beforeUpload 之前以及上传完成或者取消之后都会触发
    change(file) {
      this.upData = { ...this.UPFILEFORMDATA } // 不能直接赋值(避免改变源数据)
      if (this.type === "-1") {
        let raw = file.raw
        if (raw && raw.type.indexOf("image/") > -1) {
          this.upData.duration = this.orderData.contentTime
        }
      }
      this.$nextTick(() => {
        this.$refs.upCmp && this.$refs.upCmp.submit();
      }); // nextTick异步回调中等待子组件数据更新后再submit 否则 duration 传参对象可能无法获取
    },
    playVideo(row) {
      let ele = this.$refs.resource;
      if (ele.requestFullscreen) ele.requestFullscreen();
      else if (ele.mozRequestFullScreen) ele.mozRequestFullScreen();
      else if (ele.webkitRequestFullScreen) ele.webkitRequestFullScreen();

      if (this.data.materialType == 1) ele.play();
    },
    beforeUpload(file) {
      if (!file) return this.messageTip("请选取文件", 2);

      let fp = (file.type && file.type.toLowerCase()) || "";
      // console.log(fp)
      let isMp4 = fp === "video/mp4";
      let isImg = ["image/png", "image/jpg", "image/jpeg"].indexOf(fp) > -1;
      // 类型
      let mateType = this.type; // 1:视频 2:图片 -1:视频或图片
      if (mateType == -1 && !isMp4 && !isImg)
        return !!this.messageTip(
          "只支持格式mp4、jpg、png的文件上传，请重新选择",
          2
        );
      if (mateType == 1 && !isMp4)
        return !!this.messageTip("只支持格式mp4的文件上传，请重新选择", 2);
      if (mateType == 2 && !isImg)
        return !!this.messageTip("只支持格式jpg、png的文件上传，请重新选择", 2);
      // 大小
      let fsize = file.size;
      if (mateType == -1) {
        if (isMp4 && fsize > 1024 * 1024 * 100)
          return !!this.messageTip("请上传不超过100M的视频", 2);
        if (isImg && fsize > 1024 * 1024 * 10)
          return !!this.messageTip("请上传不超过10M的图片", 2);
      }
      if (mateType == 1 && fsize > 1024 * 1024 * 100)
        return !!this.messageTip("请上传不超过100M的视频", 2);
      if (mateType == 2 && fsize > 1024 * 1024 * 10)
        return !!this.messageTip("请上传不超过10M的图片", 2);

      this.loading = this.$loading();
    },
    uploadSuccess(res) {
      this.loading && this.loading.close();
      let snTp = this.data.screenType;
      if (res && res.code === 0) {
        if (this.data.materialType == 1) {
          if (res.videoJson) {
            let data = { ...res, screenType: snTp };
            data.duration = JSON.parse(res.videoJson).format.duration;
            this.$emit("input", data);
          } else this.messageTip("格式暂不支持，请上传mp4文件~");
        } else {
          this.$emit("input", { ...res, screenType: snTp });
        }
      } else {
        this.$message.error(res.message || res.msg);
      }
    },
    onError(error) {
      this.loading.close();
      this.messageTip("上传失败，请稍后重试");
    },
    deleteCurrentVideo() {
      this.$emit("input", { screenType: this.data.screenType });
    }
  }
};
</script>

<style lang="sass" scoped>
.icon-shenhezhong, .shenhezhong
    color: #FF7413
.icon-daishangchuan, .daishangchuan
    color: #999
.icon-zhengque, .zhengque
    color: #3FB536
.icon-cuowu, .cuowu
    color: #D50000

.submit-btn
    background: linear-gradient(315deg,rgba(80,79,83,1) 0%,rgba(40,39,41,1) 100%)

.upload_part_one
    text-align: center
    min-height: 207px
    i
        display: inline-block
        margin-top: 90px
        font-size: 46px
        color: #FF3973
.upload_part_two
    text-align: center
    i
        display: inline-block
        margin-top: 90px
        font-size: 46px
        color: #E9E9E9
.video_main
    position: relative
    background: #000
    height: 207px
    text-align: center
    video
        width: 100%
        height: 100%
        cursor: pointer
    img
        max-width: 100%
        max-height: 100%
        position: absolute
        top: 50%
        left: 50%
        transform: translate(-50%, -50%)
    .iconfont
        position: absolute
        top: 10px
        right: 10px
        color: #FF3973
        cursor: pointer
</style>
